import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";

interface TimerComponentProps {
	readonly duration: number;
	readonly onElapse: () => void;
	readonly running: boolean;
}

export function TimerComponent(props: TimerComponentProps): React.ReactElement {
	const [seconds, setSeconds] = useState<number>(props.duration);

	useEffect(() => {
		if (!props.running) {
			return;
		}

		if (seconds <= 0) {
			return props.onElapse();
		}

		const interval: number = setInterval((): void => {
			setSeconds((prev: number): number => prev - 1);
		}, 1000);

		return (): void => clearInterval(interval);
	}, [seconds, props]);

	const displayMinutes: number = Math.floor(seconds / 60);
	const displaySeconds: number = seconds % 60;

	return <Typography variant="h4">
		{displayMinutes + ":" + displaySeconds.toString().padStart(2, "0")}
	</Typography>
}
